import axios from "axios";
import { useEffect, useState } from "react";
import Api from "./Api";

const Carousel = () => {
  const [gallery, setGallery] = useState([]);
  useEffect(()=>{
    Api.get(`/all-gallery/`)
    .then((response)=>{
      //console.log(response.data);
      setGallery(response.data);      
    })    
  },[])
    return <>
    <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-indicators">
  {gallery.map((gal,index)=>{ 
    const activeClass = index===0 ? 'active': '';    
    return <button type="button" data-bs-target="#carouselExampleIndicators" key={gal.id} data-bs-slide-to={`${index}`} className={activeClass} aria-current="true" aria-label={`Slide ${index + 1}`}></button> 
    
  })}
      
    
  </div>
  <div class="carousel-inner">
    {gallery.map((gal, index)=>{
      return index===0 ? <div class="carousel-item active" key={gal.id}>
      <img src={`${global.config.live_url}${gal.image}`} height="200px" className="d-block w-100" alt="..." />
    </div> : <div class="carousel-item" key={gal.id}>
      <img src={`${global.config.live_url}${gal.image}`} height="200px" className="d-block w-100" alt="..." />
    </div>
      
    })}    
    
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
    </>
}
export default Carousel;